export const LOADING_WORKFLOW_EMP = "LOADING_WORKFLOW_EMP";
export const LOADING_WORKFLOWS_EMP = "LOADING_WORKFLOWS_EMP";
export const SAVE_LOADING_WORKFLOW_EMP = "SAVE_LOADING_WORKFLOW_EMP";
export const GET_WORKFLOW_EMP = "GET_WORKFLOW_EMP";
export const GET_WORKFLOWS_EMP = "GET_WORKFLOWS_EMP";
export const WORKFLOW_EMP_ERROR = "WORKFLOW_EMP_ERROR";
export const MESSAGE_SAVE_WORKFLOW_EMP = "MESSAGE_SAVE_WORKFLOW_EMP";